import {Component, ElementRef, OnInit, ViewChild} from '@angular/core';
import {Observable} from 'rxjs';
import {RefData} from '../../../_models/ref.data.model';
import {NgbDateParserFormatter, NgbDateStruct} from '@ng-bootstrap/ng-bootstrap';
import {CrisisAlertService} from '../../services/crisis-alert.service';
import {NgbDateFRParserFormatter} from '../case-search/ngb-date-fr-parser-formatter';

@Component({
  selector: 'app-export-file-search',
  templateUrl: './export-file-search.component.html',
  styleUrls: ['./export-file-search.component.scss'],
  providers: [{provide: NgbDateParserFormatter, useClass: NgbDateFRParserFormatter}]
})
export class ExportFileSearchComponent implements OnInit {
  identifierStyle = {};
  selectedProgramCode: string;
  isNotDownloaded: boolean;
  refData: Observable<RefData>;
  selectedDateFrom: NgbDateStruct;
  selectedDateTo: NgbDateStruct;
  readonly dateFrom: NgbDateStruct;
  readonly dateTo: NgbDateStruct;
  @ViewChild('isNotDownloadedBox', {static: false}) private isNotDownloadedBox: ElementRef;


  constructor(private crisisAlertService: CrisisAlertService) {
    const past = new Date();
    past.setFullYear(past.getFullYear() - 1);
    this.dateFrom = {year: past.getFullYear(), month: (past.getMonth() + 1), day: past.getDate()};
    const now = new Date();
    this.dateTo = {year: now.getFullYear(), month: (now.getMonth() + 1), day: now.getDate()};
  }

  ngOnInit() {
    this.reset();
    this.refData = this.crisisAlertService.refDataObs;
  }

  reset() {
    this.selectedProgramCode = null;
    this.selectedDateFrom = this.dateFrom;
    this.selectedDateTo = this.dateTo;
    this.isNotDownloaded = true;
  }

  resetForm() {
    this.reset();
    this.identifierStyle = {};
    try { // angular issue of late rendering
      this.isNotDownloadedBox.nativeElement.checked = true;
    } catch (e) {
      console.log(e);
    }
  }

  searchExportFiles() {
    let query = '';
    if (this.selectedProgramCode) {
      if ('ALL' !== this.selectedProgramCode) {
        query = 'programCode=' + this.selectedProgramCode;
      }
    } else {
      this.identifierStyle = {'border': '2px solid red', 'background-color': '#f2dede'};
      return;
    }
    if (this.selectedDateFrom) {
      query = query + '&dateFrom=' + this.dateToString(this.selectedDateFrom);
    }
    if (this.selectedDateTo) {
      query = query + '&dateTo=' + this.dateToStringPlusOneDay(this.selectedDateTo);
    }
    query = query + '&isDownloaded=' + (!this.isNotDownloaded);
    /* NO DEFAULT
    if (query === '') {
      console.log('Query is empty hence setting it to default');
      query = this.crisisAlertService.defaultQuery;
    }*/
    console.log('Files Query >>' + query);
    this.crisisAlertService.searchExportFiles(query);
    this.crisisAlertService.pushDownloadSearchTrigger(true);
  }

  dateToStringPlusOneDay(date: NgbDateStruct) {
    return date.year + '-' + date.month + '-' + date.day;
  }

  dateToString(date: NgbDateStruct) {
    // yyyy-MM-dd
    return date.year + '-' + date.month + '-' + date.day;
  }

  checkFilterValue(event: any) {
    this.isNotDownloaded = event.currentTarget.checked;
  }

  checkIdentifier() {
    setTimeout(() => {
      if (this.selectedProgramCode) {
        this.identifierStyle = {};
      }
    }, 500);
  }
}
